import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  Button,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import DraggableDialogWrapper from 'components/DraggableDialogWrapper/DraggableDialogWrapper';

const EmployeeBusinessesModal = ({
  open,
  onClose,
  employee,
  allBusinessList,
  jobs,
}) => {
  const { t } = useTranslation();

  const getBusinessName = (businessUuid) => {
    return (
      allBusinessList?.find((item) => item?.uuid === businessUuid)
        ?.companyName || ''
    );
  };

  const getJobTitle = (businessUuid, jobId) => {
    const entry = jobs.find((item) => Object.keys(item).includes(businessUuid));
    const jobsData = entry ? entry[businessUuid] : [];
    return jobsData?.find((job) => job._id === jobId)?.title || '';
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="employee-businesses-dialog-title"
      fullWidth={true}
      PaperComponent={DraggableDialogWrapper}
      PaperProps={{
        sx: {
          width: '538px',
          maxWidth: '100%',
          background: '#FFFFFF',
        },
      }}
    >
      <DialogTitle
        sx={{
          pt: 2,
          pb: 2,
          fontSize: '24px',
          fontWeight: 400,
          lineHeight: '32px',
          position: 'relative',
          color: '#1D1B20',
        }}
      >
        {`${employee?.firstname} ${employee?.lastname}`}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#000000',
            opacity: '0.54',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 0, pb: 3 }}>
        {employee?.businesses?.map((business) => {
          return (
            <Box key={business.businessUuid}>
              {getBusinessName(business.businessUuid) && (
                <Typography
                  key={`${business.businessUuid}`}
                  component="li"
                  sx={{
                    fontSize: '15px',
                    lineHeight: '28px',
                    letterSpacing: '0.25px',
                    color: '#49454F',
                    mb: 1,
                    '&:last-child': {
                      mb: 0,
                    },
                  }}
                >
                  {`${getBusinessName(business.businessUuid)} - ${business.jobs
                    ?.map((job) => getJobTitle(business.businessUuid, job._id))
                    .join(', ')}`}
                </Typography>
              )}
            </Box>
          );
        })}
      </DialogContent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2,
          borderTop: '1px solid #E7E7E7',
        }}
      >
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            minWidth: '64px',
            backgroundColor: '#2D7FF9',
            '&:hover': {
              backgroundColor: '#2D7FF9',
            },
          }}
        >
          {t('OK')}
        </Button>
      </Box>
    </Dialog>
  );
};

export default EmployeeBusinessesModal;
